export interface MatchRun {
  remainingIds: string[];
  total: number;
}

export interface MatchRunStep {
  run: MatchRun;
  nextId: string | null;
  position: number;
}

export function startMatchRun(requestIds: string[]): MatchRun {
  return { remainingIds: [...requestIds], total: requestIds.length };
}

export function advanceMatchRun(
  run: MatchRun,
  currentId: string,
  stillPendingIds: ReadonlySet<string>,
): MatchRunStep {
  const withoutCurrent = run.remainingIds.filter(id => id !== currentId);
  const firstStillPending = withoutCurrent.findIndex(id => stillPendingIds.has(id));
  const remainingIds = firstStillPending === -1 ? [] : withoutCurrent.slice(firstStillPending);
  const nextRun: MatchRun = { remainingIds, total: run.total };
  return {
    run: nextRun,
    nextId: remainingIds[0] ?? null,
    position: run.total - remainingIds.length + 1,
  };
}
